import styled from "styled-components";
import { colors, typography } from "@streeteasy/design-system";

const { Body, PrimarySmall, SecondarySmall } = typography;
const { GRAY_LIGHT } = colors;

export const ValuationContent = styled.div`
  line-height: 26px;
  margin-top: 15px;
`;

export const Price = styled(PrimarySmall).attrs({
  as: "strong"
})`
  display: block;
  font-weight: bold;
`;

export const LabelText = styled(Body).attrs({
  as: "span"
})``;

export const Label = styled.div`
  margin: 5px 0;
`;

export const Value = styled(SecondarySmall).attrs({
  as: "strong"
})``;

export const Spacer = styled.hr`
  background-color: ${GRAY_LIGHT};
  margin-bottom: 0;
`;

export const TooltipContainer = styled.span`
  display: inline-block;
  margin-left: 5px;
`;

export const TooltipContent = styled.div`
  line-height: 20px;
  padding: 5px;
`;
